<template>
	<Col>
		<v-menu rounded="lg" bottom left :minWidth="516" :maxWidth="516" offset-y dense :close-on-content-click="false" open-on-hover>
			<template v-slot:activator="{ on, attrs }">
				<div v-bind="attrs" v-on="on">
					<SIcon name="installation-tab-info" width="12" height="18" />
				</div>
			</template>
			<Col class="content-container flex-justify-space-between display-flex flex-column width-100 pa-4">
				<h3 class="reg">
					As an admin, you have visibility into all spaces in your workspace, this includes spaces you’re not a collaborator in and personal
					spaces of other users. Turning this on includes data from all spaces.
				</h3>
			</Col>
		</v-menu>
	</Col>
</template>

<script>
export default { name: 'IncludeDataForAdminExplanation' };
</script>

<style scoped lang="scss">
.content-container {
	font-size: 14px;
	color: #4d4c52;
	background: var(--white);
}
</style>
